/* eslint-disable no-console */
import { useEffect, useRef, useState } from 'react';

import Spinner from '@/components/common/Spinner/Spinner';
import { useSearchUplift } from '@/utils/data-helpers/upliftSearch';
import { useColumns } from './components/grid/columns';
import { UpliftAction, UpliftContractLinesGrid } from './components/ContractLinesGrid';
import useConvertUpliftDataFormat from './hooks/useConvertUpliftDataFormat';
import useCalculateContractLineUplift, { UpliftData_Updated_Contractline } from
  './hooks/useCalculateContractLineUplift';
import UpliftToolSearch from './components/UpliftToolSearch';
import './uplift-search.scss';

export default function UpliftToolContainer() {
  const {
    getContractLines, loading, searchResults
  } = useSearchUplift();

  const promptReference = useRef<HTMLDivElement>(null);
  const [upliftedLines, setUpliftedLines] = useState<UpliftData_Updated_Contractline[]>([]);

  const { calculateContractLineUplift, upliftedContractLine } = useCalculateContractLineUplift();
  useEffect(() => {

    if (upliftedContractLine) {
      const filtered = upliftedLines.filter(x => x.contractLineID !== upliftedContractLine.contractLineID);
      setUpliftedLines(() => { return [...filtered, upliftedContractLine]; });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upliftedContractLine]);

  const {
    data
  } = useConvertUpliftDataFormat(searchResults, upliftedLines);

  const displayApply = () => {
    const span = promptReference.current;
    span!.className = 'inline-apply-visible';
  };
  const stockCodesAndNames = searchResults.map(cl => ({
    stockCode: cl?.product?.stockCode as string,
    stockName: cl?.product?.stockName as string
  }));

  const columns = useColumns(calculateContractLineUplift, displayApply, stockCodesAndNames);

  return (
    <>
      <UpliftToolSearch getSearchResults={getContractLines} />

      {loading && (
        <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
          <Spinner />
        </div>
      )}

      {!loading && searchResults?.length ? (
        <UpliftContractLinesGrid
          data={data}
          columns={columns}
          promptReference={promptReference}
          clearUplifts={(action: UpliftAction) => {
            setUpliftedLines(lines => lines.map(line => ({ ...line, action })));
          }}
        />
      ) : null}

      {!loading && !searchResults?.length ? (
        <div className="d-flex justify-content-center">
          <p className="mt-20 mb-40 c-title">
            This contract does not have any contract lines yet
          </p>
        </div>
      ) : null}

    </>
  );
}
